import { deleteField } from 'firebase/firestore';

/**
 * Profile keys that belonged to Stripe Connect / onboarding and must not remain on artist profiles.
 * UK/US manual payouts use bank_sort_code / bank_account_number / account_number / sort_code / paypal_email / venmo_handle — never delete those here.
 */
export const STRIPE_LEGACY_PROFILE_KEYS = [
  'stripe_account_id',
  'stripe_account_created_at',
  'stripe_customer_id',
  'stripe_account_status',
  'stripe_onboarding_complete',
  'stripe_charges_enabled',
  'stripe_payouts_enabled',
  'stripe_details_submitted',
  'stripe_connect_account_id',
  'stripe_last_onboarding_url',
  'stripe_refresh_url',
  'stripe_return_url',
];

export function profileHasStripeLegacyData(profile) {
  if (!profile || typeof profile !== 'object') return false;
  return STRIPE_LEGACY_PROFILE_KEYS.some((key) => {
    const v = profile[key];
    if (v === undefined || v === null || v === '') return false;
    return true;
  });
}

/** Payload for `updateDoc(profileRef, …)` — removes all legacy Stripe fields. */
export function buildStripeLegacyProfilePurgeUpdate() {
  const out = {};
  for (const key of STRIPE_LEGACY_PROFILE_KEYS) {
    out[key] = deleteField();
  }
  return out;
}

/** True if artist has YSR manual payout details on file (UK bank or US PayPal/Venmo). */
export function hasManualPayoutDetailsOnProfile(artist) {
  if (!artist || typeof artist !== 'object') return false;
  const cc = String(artist.country || 'GB')
    .toUpperCase()
    .slice(0, 2);
  if (cc === 'US') {
    const paypal = String(artist.paypal_email || '').trim();
    const venmo = String(artist.venmo_handle || '').trim();
    if (paypal.includes('@')) return true;
    if (venmo.length >= 2) return true;
    return false;
  }
  const sort =
    String(artist.sort_code || artist.bank_sort_code || '')
      .replace(/\D/g, '')
      .length >= 6;
  const acct =
    String(artist.account_number || artist.bank_account_number || '')
      .replace(/\D/g, '')
      .length >= 6;
  return sort && acct;
}
